<template>
  <div class="container-detail">
    <!-- 主题信息 -->
    <div class="container-page-body">
      <div class="pages-list">
        <!-- 申请信息 -->
        <div class="pages-box">
          <van-skeleton
              :row="4"
              :loading="loading"
              animate
              round
              :style="'padding:10px'"
          >
            <div class="pages-box-title">
              <div class="info">申请信息</div>
              <div class="img">
                <img v-show="data.lookForm.status==='underway'"
                     src="../../../assets/image/repair/repair/icon-shenpi.png">
                <img v-show="data.lookForm.status==='refuse'" src="../../../assets/image/repair/repair/icon-jujue.png">
                <img v-show="data.lookForm.status==='agree'" src="../../../assets/image/repair/repair/icon-tongyi.png">
                <img v-show="data.lookForm.status==='revoke'" src="../../../assets/image/repair/repair/icon-cexiao.png">
                <img v-show="data.lookForm.status==='0'" src="../../../assets/image/repair/repair/icon-fenpei.png">
                <img v-show="data.lookForm.status==='1'" src="../../../assets/image/repair/repair/icon-weixiu.png">
                <img v-show="data.lookForm.status==='2'" src="../../../assets/image/repair/repair/icon-success.png">
              </div>
            </div>
            <div class="pages-box-body">
              <div class="pages-box-item">
                <div class="field">申请人：</div>
                <div class="value">{{ data.lookForm.applyUserName || '' }}</div>
              </div>
              <div class="pages-box-item">
                <div class="field">报修类别：</div>
                <div class="value">{{ data.lookForm.repairTypeName || '' }}</div>
              </div>
              <div class="pages-box-item">
                <div class="field">报修范围：</div>
                <div class="value">{{ data.lookForm.repairScopeName || '' }}</div>
              </div>
              <div class="pages-box-item">
                <div class="field">报修地址：</div>
                <div class="value">{{ data.lookForm.repairAddress || '' }}</div>
              </div>
            </div>
          </van-skeleton>
        </div>
        <!-- 报修问题 -->
        <div class="pages-box">
          <van-skeleton
              :row="3"
              :loading="loading"
              animate
              round
              :style="'padding:10px'"
          >
            <div class="pages-box-title ">
              <div class="info">报修问题</div>
            </div>
            <div class="pages-box-desc">
              <div class="field">{{ data.lookForm.msg }}</div>
              <div class="img" v-show="data.lookForm.pics.length">
                <img v-for="(item, index) in data.lookForm.pics" :key="index" :src="item.thumbnailUrl"
                     @click="btnShowPic(data.lookForm.pics, index)">
              </div>
            </div>
          </van-skeleton>
        </div>
        <!-- 审批流程 -->
        <div class="pages-box">
          <van-skeleton
              :row="9"
              :loading="loading"
              animate
              round
              :style="'padding:10px'"
          >
            <div v-show="data.lookForm.status==='underway' ||
          data.lookForm.status==='refuse' ||
          data.lookForm.status==='agree' ||
          data.lookForm.status==='0' ||
          data.lookForm.status==='1' ||
          data.lookForm.status==='2'">
              <div class="pages-box-title">
                <div class="info">审批流程</div>
              </div>
              <div class="pages-box-flow">
                <desc-item :list="workflowListRecord"/>
              </div>
            </div>
          </van-skeleton>
        </div>
        <!-- 维修信息 -->
        <div class="pages-box">
          <van-skeleton
              :row="3"
              :loading="loading"
              animate
              round
              :style="'padding:10px'"
          >
            <div v-show="data.lookForm.repairUserName>0">
              <div class="pages-box-title ">
                <div class="info">维修信息</div>
              </div>
              <div class="pages-box-repair">
                <div class="field">维修人：</div>
                <div class="value">
                  <div class="name">{{ data.lookForm.repairUserName }}</div>
                  <div class="img" @click="showDialogPhone"><img src="../../../assets/image/repair/repair/phone.png">
                  </div>
                </div>
              </div>

              <div v-for="(item, index) in data.lookForm.repairFeedRecordVOS" :key="index">
                <div class="pages-box-desc">
                  <div class="field">{{ item.userName }}：{{ item.feedbackMsg }}</div>
                  <div class="img" v-show="item.pics.length">
                    <img v-for="(value, key) in item.pics" :key="key" :src="value.thumbnailUrl"
                         @click="btnShowPic(item.pics, key)">
                  </div>
                </div>
              </div>
            </div>
          </van-skeleton>
        </div>
      </div>
    </div>

    <!-- 底部菜单，管理员 和 维修员 -->
    <div class="container-page-footer"
         v-show="data.lookForm.status==='underway'"
    >
      <div class="footer-button-list">
        <div class="button button-refuse"
             @click="buttonRefuse">拒绝
        </div>
        <div class="button button-agree"
             @click="buttonAgree">同意
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {Dialog, ImagePreview, Skeleton, Step, Steps, Toast} from "vant";
import {useStore} from "vuex";
import DescItem from "@/components/process-desc/components/desc-item.vue";

export default {
  name: "applyDetail",
  components: {
    [Skeleton.name]: Skeleton,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [ImagePreview.Component.name]: ImagePreview.Component,
    DescItem,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    let loading = ref(true);
    let id = ref('');
    let feedbackForm = ref({
      feedback: '',
      pics: [],
    });
    let data = ref({
      lookForm: {
        applyPhone: '',
        applyUserName: '',
        approveCode: '',
        createTime: '',
        id: '',
        isCanDistribute: '',
        msg: '',
        pics: [],
        repairAddress: '',
        repairFeedRecordVOS: [],
        repairScope: '',
        repairScopeName: '',
        repairStatus: '',
        repairTime: '',
        repairType: '',
        repairTypeName: '',
        repairUserName: '',
        repairUserPhone: '',
        status: '',
        statusName: '',
      },
    });

    const btnShowPic = (list, index) => {
      if (list) {
        let images = [];
        list.map((item) => {
          images.push(item.ossUrl);
        });
        console.log('btnShowPic', list, index)
        ImagePreview({
          images: images,
          startPosition: index,
          closeable: true,
        });
      }
    };

    const showDialogPhone = () => {
      Dialog.confirm({
        title: '维修电话',
        message: `确认向【${data.value.lookForm.repairUserName}】拨打维修电话吗？`,
      }).then(() => {
        const a = document.createElement("a");
        a.href = "tel:" + data.value.lookForm.repairUserPhone;
        a.click();
      });
    };

    const getRecordDetailApi = (params) => store.dispatch("repair/getRecordDetail", params);
    const getApplyDetail = async () => {
      console.log('getApplyDetail', id.value)
      let r = await getRecordDetailApi({
        id: id.value
      });

      if (r.message == "success") {
        data.value.lookForm = r.data;
      } else {
        Toast.fail(r.message);
      }
      getWorkflowRecord();
      loading.value = false;
    };

    const buttonRefuse = () => {
      console.log('拒绝');
      router.push(`/repair/report/auditRefuse?applyId=` + id.value + `&bizType=repair&approveCode=` + data.value.lookForm.approveCode);
    };

    const buttonAgree = () => {
      console.log('同意');
      router.push(`/repair/report/auditAgree?applyId=` + id.value + `&bizType=repair&approveCode=` + data.value.lookForm.approveCode);
    };

    // 审批流程
    const workflowListRecord = ref({});
    const workflowRecordInfo = params => store.dispatch("studentLeave/workflowRecordInfo", params);
    const getWorkflowRecord = async () => {
      let params = {
        approveCode: data.value.lookForm.approveCode,
        bizType: "repair"
      };
      let r = await workflowRecordInfo(params);
      let {success} = r;
      if (!success) {
        Toast.fail(r.message);
        return;
      }
      let {applyHeadUrl, applyTime, applyUserName, detailList} = r.data || {};
      // 查询当前用户所在层级
      let level = -1;
      detailList.map(item => {
        if (level == -1 && !item.isFinish) {
          level = item.level;
        }
      });
      // getApproverInfo({approveCode: data.value.lookForm.approveCode, level});

      let applyUser = {
        approveTime: applyTime, //审批时间
        applyUser: "申请人", //审批(申请)人
        approveResult: "agree",
        userList: [
          {
            headUrl: applyHeadUrl, //用户头像
            userName: applyUserName //用户姓名
          }
        ] //人员列表
      };
      detailList.map(item => {
        item.applyUser = "审批人";
      });
      detailList.unshift(applyUser);
      workflowListRecord.value = detailList;
    };
    // 是否需要指定下一级审批人
    // const isApproverData = ref({});
    // const approverInfo = params => store.dispatch("studentLeave/approverInfo", params);
    // const getApproverInfo = async ({approveCode, level}) => {
    //   let params = {
    //     approveCode,
    //     bizType: "repair",
    //     level
    //   };
    //   let r = await approverInfo(params);
    //   if (!r || !r.success) {
    //     Toast.fail(r.message);
    //     return;
    //   }
    //   isApproverData.value = r.data;
    // };

    onMounted(() => {
      id.value = router.currentRoute.value.query.id;
      getApplyDetail();
    });

    return {
      loading,
      id,
      feedbackForm,
      data,
      showDialogPhone,
      getApplyDetail,
      buttonRefuse,
      buttonAgree,
      getWorkflowRecord,
      workflowListRecord,
      btnShowPic,
    };
  },
};
</script>
<style lang="less" scoped>
.container-page-header {
  height: 100%;
  font-size: 12px;
  margin-bottom: 48px;

  .top-tabs {
    position: fixed;
    top: 48px;
    left: 0;
    right: 0;
    z-index: 900;
  }

  .page-top-line {
    position: fixed;
    top: 48px;
    left: 0;
    right: 0;
    z-index: 900;
    height: 3px;
    background-color: #ffffff;
    border-bottom: 1px solid #F2F4FA;
  }

  .top-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 900;
    height: 48px;
    color: #fff;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 12px;
    box-sizing: border-box;

    .back {
      width: 36px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .left_img {
        width: 24px;
        height: 24px;
      }
    }

    .page_title {
      font-weight: 500;
      color: #343434;
      line-height: 20px;
      font-size: 18px;
    }
  }
}

.container-page-body {
  background-color: #F2F4FA;

  .pages-list {
    padding: 10px 12px 70px 12px;
    min-height: 700px;

    .pages-box {
      background-color: #FFFFFF;
      margin-bottom: 8px;
      border-radius: 10px;

      .pages-box-title {
        padding: 0 12px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .info {
          color: #333333;
          font-size: 15px;
          font-weight: bold;
        }

        .img img {
          position: relative;
          width: 54px;
          height: 51px;
          top: 15px;
          right: 0px;
        }
      }

      .pages-box-body {
        padding: 12px 12px 20px;

        .pages-box-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 15px;
          font-size: 15px;

          .field {
            color: #666666;
          }

          .value {
            color: #333333;
            display: table;
            max-width: 235px;
          }
        }
      }

      .pages-box-desc {
        padding: 12px 12px 20px;

        .field {
          color: #333333;
          font-size: 15px;
          margin-bottom: 10px;
        }

        .img img {
          width: 64px;
          height: 64px;
          margin-right: 5px;
          border-radius: 5px;
        }
      }

      .pages-box-flow {
        padding: 0 12px 0;
        min-height: 210px;

        .title-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;

          .title {
            color: #4275FD;
            font-size: 15px;
          }

          .date {
            color: #999999;
            font-size: 13px;
          }
        }

        .people-list {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 10px;

          .people-box {
            margin-right: 5px;

            .people-box-img img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
            }

            .people-box-name {
              color: #333333;
              font-size: 13px;
              text-align: center;
            }
          }
        }

        .label-info {
          padding: 10px;
          background-color: #F2F4F9;
          font-size: 13px;
          color: #666666;
          border-radius: 5px;
        }
      }

      .pages-box-repair {
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 15px;

        .field {
          color: #666666;
        }

        .value {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .name {
            width: 160px;
            text-align: right;
            color: #333333;
            margin-right: 10px;
          }

          .img img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }
}

.container-page-footer {
  position: fixed;
  width: 100%;
  height: 70px;
  bottom: 0;
  background-color: #ffffff;
  border: 1px solid #F2F4FA;
  z-index: 99;

  .footer-button-list {
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .button {
      border: 1px solid #4275FD;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 30px;
      margin: 0px 10px;
      font-size: 15px;
    }

    .button-allocate {
      color: #4275FD;
      background-color: #ffffff;
    }

    .button-feedback {
      color: #ffffff;
      background-color: #4275FD;
    }

    .button-refuse {
      color: #4275FD;
      background-color: #ffffff;
    }

    .button-agree {
      color: #ffffff;
      background-color: #4275FD;
    }
  }
}

.popup-search {
  .popup-search-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;
    margin-bottom: 10px;

    .popup-search-header__empty {
      width: 60px;
      height: 54px;
      line-height: 54px;
    }

    .popup-search-header__title {
      height: 54px;
      line-height: 54px;
      font-weight: 500;
      text-align: center;
      font-size: 17px;
      color: #333333;
    }

    .popup-search-header__cancel {
      height: 54px;
      line-height: 54px;
      width: 60px;
      padding: 0 10px;
      font-size: 15px;
      color: #333333;
    }
  }

  .popup-search-body {
    width: 100%;
    min-height: 200px;
    border-bottom: 1px solid #E5E5E5;
    margin-bottom: 12px;

    .popup-search-body__textarea {
      margin-bottom: 5px;
    }

    .popup-search-body__uploader {
      padding: 5px 10px;
    }
  }

  .popup-search-footer {
    clear: both;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;

    .popup-search-footer__button {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border: 1px solid #4174FD;
      border-radius: 20px;
    }

    .button-save {
      color: #ffffff;
      background-color: #4174FD;
    }

    .button-reset {
      color: #4275FD;
      background-color: #ffffff;
    }

    .button-confirm {
      color: #ffffff;
      background-color: #4174FD;
    }

  }
}
</style>
